





























































































import { Component, Vue } from 'vue-property-decorator';
import { UserStore } from "@/store/user-module";

@Component({
  components: {},
})
export default class RoleExplanationTable extends Vue {
  get useProjectTimeTracking(){
    return !UserStore.userSettings.useBasicTimeTracking;
  }
}
